import { useListTeamsForUserLazyQuery } from 'generated-graphql/hooks/apollo-hooks';
import { ListTeam } from 'generated-graphql/types';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { fetchAllPaginatedItems } from 'core/utils/apollo/fetchAllPaginatedItems';

// Every page of the teams the user can put a talent list in. Throws on failure.
export const useFetchListTeams = () => {
  const organization = useOrganization();
  const [fetchTeams] = useListTeamsForUserLazyQuery();

  const fetchListTeams = (): Promise<ListTeam[]> =>
    fetchAllPaginatedItems(async (nextToken) => {
      const { data, error } = await fetchTeams({
        variables: { organizationId: organization.id, nextToken }
      });
      if (error) {
        throw error;
      }

      return data?.listTeamsForUser;
    });

  return { fetchListTeams };
};
